
const DEFAULT_TYPOGRAPHY_STYLES = {
  h1: {
    fontSize: '2rem',
    fontWeight: 800,
    lineHeight: '1.18',
    [`@media (max-width:768px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.20',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.20',
    },
  },
  h2: {
    fontSize: '1.75rem',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:768px)`]: {
      fontSize: '1.3rem',
      lineHeight: '1.27',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.3rem',
      lineHeight: '1.27',
    },
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:768px)`]: {
      fontSize: '1.25rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.25rem',
      lineHeight: '1.32',
    },
  },
  h4: {
    fontSize: '1.375rem',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:768px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 800,
    lineHeight: '1.28',
    [`@media (max-width:768px)`]: {
      fontSize: '1rem',
      lineHeight: '1.28',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.28',
    },
  },
  h6: {
    fontSize: '1.125rem',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:768px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.24',
    },
  },
  subtitle1: {
    fontSize: '1.3rem',
    fontWeight: 700,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: '1.1rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.1rem',
      lineHeight: '1.32',
    },
  },
  subtitle2: {
    fontSize: '1.125rem',
    fontWeight: 700,
    lineHeight: '1.32',
    [`@media (max-width:768px)`]: {
      fontSize: '1rem',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.24',
    },
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:768px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.56',
    },
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: '0.8125rem',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.8125rem',
      lineHeight: '1.4',
    },
  },
  caption: {
    fontSize: 'clamp(0.5rem, 0.75rem, 0.875rem)',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
  },
  buttoninput: {
    fontSize: '1.25rem', // body1과 동일
    fontWeight: 700,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: '1.25rem',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
    },
  },
  pagination: {
    fontSize: 'clamp(0.625rem, 0.875rem, 1rem)', // body2와 동일하게 작게
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
  },
  textarea: {
    fontSize: '1.3rem',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:768px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
  },
};

const CLAMP_TYPOGRAPHY_STYLES = {
  h1: {
    fontSize: 'clamp(1.5rem, 2rem, 2.5rem)',
    fontWeight: 800,
    lineHeight: '1.18',
    [`@media (max-width:768px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.20',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.20',
    },
  },
  h2: {
    fontSize: 'clamp(1.5rem, 1.75rem, 2rem)',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:768px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.27',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.5rem',
      lineHeight: '1.27',
    },
  },
  h3: {
    fontSize: 'clamp(1.25rem, 1.5rem, 1.75rem)',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:768px)`]: {
      fontSize: '1.25rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.25rem',
      lineHeight: '1.32',
    },
  },
  h4: {
    fontSize: 'clamp(1.125rem, 1.375rem, 1.5rem)',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:768px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.125rem',
      lineHeight: '1.32',
    },
  },
  h5: {
    fontSize: 'clamp(1rem, 1.25rem, 1.375rem)',
    fontWeight: 800,
    lineHeight: '1.28',
    [`@media (max-width:768px)`]: {
      fontSize: '1rem',
      lineHeight: '1.28',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.28',
    },
  },
  h6: {
    fontSize: 'clamp(0.9375rem, 1.125rem, 1.25rem)',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:768px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.24',
    },
  },
  subtitle1: {
    fontSize: 'clamp(1.1rem, 1.3rem, 1.5rem)',
    fontWeight: 800,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: '1.1rem',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1.1rem',
      lineHeight: '1.32',
    },
  },
  subtitle2: {
    fontSize: 'clamp(1rem, 1.125rem, 1.25rem)',
    fontWeight: 800,
    lineHeight: '1.32',
    [`@media (max-width:768px)`]: {
      fontSize: '1rem',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '1rem',
      lineHeight: '1.24',
    },
  },
  body1: {
    fontSize: 'clamp(0.9375rem, 1rem, 1.125rem)',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:768px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.9375rem',
      lineHeight: '1.56',
    },
  },
  body2: {
    fontSize: 'clamp(0.8125rem, 0.875rem, 1rem)',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: '0.8125rem',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: '0.8125rem',
      lineHeight: '1.4',
    },
  },
  caption: {
    fontSize: 'clamp(0.5rem, 0.75rem, 0.875rem)',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
  },
  buttoninput: {
    fontSize: 'clamp(0.75rem, 1rem, 1.125rem)', // body1과 동일
    fontWeight: 700,
    lineHeight: '1.48',
    [`@media (max-width:768px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
  },
  pagination: {
    fontSize: 'clamp(0.625rem, 0.875rem, 1rem)', // body2와 동일하게 작게
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
  },
  textarea: {
    fontSize: '1.3rem',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:768px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
  },
};

const FLUID_TYPOGRAPHY_STYLES = {
  h1: {
    fontSize: 'var(--step-2)',
    fontWeight: 800,
    lineHeight: '1.18',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step-1)',
      lineHeight: '1.20',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step-1)',
      lineHeight: '1.20',
    },
  },
  h2: {
    fontSize: 'var(--step-1)',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step-1)',
      lineHeight: '1.27',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step-1)',
      lineHeight: '1.27',
    },
  },
  h3: {
    fontSize: 'var(--step-0)',
    fontWeight: 800,
    lineHeight: '1.2',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
  },
  h4: {
    fontSize: 'var(--step--1)',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
  },
  h5: {
    fontSize: 'var(--step--1)',
    fontWeight: 800,
    lineHeight: '1.28',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.28',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.28',
    },
  },
  h6: {
    fontSize: 'var(--step--1)',
    fontWeight: 800,
    lineHeight: '1.24',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.24',
    },
  },
  subtitle1: {
    fontSize: 'var(--step--1)',
    fontWeight: 800,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.32',
    },
  },
  subtitle2: {
    fontSize: 'var(--step-0)',
    fontWeight: 800,
    lineHeight: '1.32',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.24',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.24',
    },
  },
  body1: {
    fontSize: 'var(--step-0)',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.56',
    },
  },
  body2: {
    fontSize: 'var(--step--1)',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step--1)',
      lineHeight: '1.4',
    },
  },
  caption: {
    fontSize: 'clamp(0.5rem, 0.75rem, 0.875rem)',
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.4375rem, 0.6875rem, 0.75rem)',
      lineHeight: '1.32',
    },
  },
  buttoninput: {
    fontSize: 'clamp(0.75rem, 1rem, 1.125rem)', // body1과 동일
    fontWeight: 700,
    lineHeight: '1.48',
    [`@media (max-width:768px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.625rem, 0.9375rem, 1rem)',
      lineHeight: '1.56',
    },
  },
  pagination: {
    fontSize: 'clamp(0.625rem, 0.875rem, 1rem)', // body2와 동일하게 작게
    fontWeight: 500,
    lineHeight: '1.4',
    [`@media (max-width:768px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'clamp(0.5rem, 0.8125rem, 0.875rem)',
      lineHeight: '1.4',
    },
  },
  textarea: {
    fontSize: 'var(--step-1)',
    fontWeight: 500,
    lineHeight: '1.48',
    [`@media (max-width:768px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.56',
    },
    [`@media (max-height:600px)`]: {
      fontSize: 'var(--step-0)',
      lineHeight: '1.56',
    },
  },
};

export const TYPOGRAPHY_STYLES_MAP = {
  Default: DEFAULT_TYPOGRAPHY_STYLES,
  Fluid: FLUID_TYPOGRAPHY_STYLES,
  Clamp: CLAMP_TYPOGRAPHY_STYLES,
};
